import { Model } from 'es6/components/model'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Модель комментария/ответа на комментарий в карточке новости.
 */
@Defaults({
  urlRoot: `${entryScriptName}/api/v3/news-comment`,
  expand: 'expand=user,comment_status',
})
export class NewsComment extends Model {}
